import { defineComponent as _defineComponent } from 'vue'
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { AppHeader, AppFooter }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})